import * as React from "react";
import { IGoalStreakInfoDTO } from "motw_core/DTOs/GoalStreakInfo/IGoalStreakInfoDTO";
import Hyperlink from "source/app/presentation/Shared/Link/Hyperlink";
import { dailyGoalsActionPillClass } from "./DailyGoalsActionPill";
import { DailyGoals } from "./DailyGoals";

export function ToggleFutureDailyGoals({
    goalStreakInfos,
    DailyGoals,
}: {
    goalStreakInfos: IGoalStreakInfoDTO[];
    DailyGoals: DailyGoals;
}) {
    const numFutureDailyGoals = goalStreakInfos.filter(
        (gsi) => gsi.isFutureDailyGoal
    ).length;

    if (numFutureDailyGoals === 0) {
        return null;
    }

    const { showFutureDailyGoals } = DailyGoals.state;
    const toggleText = showFutureDailyGoals ? `Hide` : `Show`;

    return (
        <Hyperlink
            whenClicked={() =>
                DailyGoals.setState({
                    showFutureDailyGoals: !showFutureDailyGoals,
                })
            }
            classes={dailyGoalsActionPillClass}
        >
            {toggleText} {numFutureDailyGoals} future daily goal(s)
        </Hyperlink>
    );
}
